import i18n, { FormatFunction } from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { isDate } from 'date-fns';
import { de, enGB, enUS, es, frCA, fr, hi, it, ja, ko, pl, ptBR, pt, vi, zhCN } from 'date-fns/locale';
import 'moment/locale/de';
import 'moment/locale/en-gb';
import 'moment/locale/es';
import 'moment/locale/fr-ca';
import 'moment/locale/fr';
import 'moment/locale/hi';
import 'moment/locale/it';
import 'moment/locale/ja';
import 'moment/locale/ko';
import 'moment/locale/pl';
import 'moment/locale/pt-br';
import 'moment/locale/pt';
import 'moment/locale/vi';
import 'moment/locale/zh-cn';
import packageJSON from '../../../package.json';

const locales: any = {
  deDE: de,
  enGB,
  enUS,
  esES: es,
  esMX: es,
  frCA,
  frFR: fr,
  hiIN: hi,
  itIT: it,
  jaJP: ja,
  koKR: ko,
  plPL: pl,
  ptBR,
  ptPT: pt,
  viVN: vi,
  zhCN
};

i18n
  // i18next-http-backend
  // loads translations from your server
  // https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    // debug: true,
    fallbackLng: 'enUS',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format: ((value, format, lng = 'enUS') => {
        if (isDate(value)) {
          const locale = locales[lng];
          let options: Intl.DateTimeFormatOptions = {};
          switch (format) {
            case 'time': // 9:18 AM
              options = {
                hour: 'numeric',
                minute: 'numeric'
              };
              break;
            case 'numericDay': // 1
              options = { day: 'numeric' };
              break;
            case 'monthDay': // Mar 1
              options = {
                day: 'numeric',
                month: 'short'
              };
              break;
            case 'monthYear': // March 2023
              options = {
                month: 'long',
                year: 'numeric'
              };
              break;
            case 'monthDayYear': // March 1, 2023
              options = {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
              };
              break;
            case 'weekdayMonthDay': // Wed, Mar 1
              options = {
                weekday: 'short',
                day: 'numeric',
                month: 'short'
              };
              break;
            case 'weekdayMonthDayYear': // Wednesday, March 1, 2023
              options = {
                weekday: 'long',
                day: 'numeric',
                month: 'long',
                year: 'numeric'
              };
              break;
            case 'timeMonthDayYear': // Mar 1, 2023, 9:18 AM
              options = {
                hour: 'numeric',
                minute: 'numeric',
                day: 'numeric',
                month: 'short',
                year: 'numeric'
              };
              break;
            default:
          }

          return new Intl.DateTimeFormat(locale.code, options).format(value);
        }
        return value;
      }) as FormatFunction
    },
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${packageJSON.version}`
    }
  });

export default i18n;
